// Shared exam-duration helpers. The user enters minutes; we cap at 5 hours and show an hours label.
export const MAX_EXAM_DURATION_MINUTES = 300; // 5 hours

/**
 * Human-friendly label for a minutes value, e.g. 90 -> "1 saat 30 dəq".
 * Returns "" for empty / non-positive input. `t` supplies the localized unit words
 * (common.hoursShort / common.minutesShort).
 */
export function formatMinutesAsHours(minutes, t) {
  const total = Math.floor(Number(minutes));
  if (!Number.isFinite(total) || total <= 0) return "";
  const hours = Math.floor(total / 60);
  const mins = total % 60;
  const hLabel = t("common.hoursShort");
  const mLabel = t("common.minutesShort");
  if (hours > 0 && mins > 0) return `${hours} ${hLabel} ${mins} ${mLabel}`;
  if (hours > 0) return `${hours} ${hLabel}`;
  return `${mins} ${mLabel}`;
}
